import { type RJSFSchema } from '@rjsf/utils'

export interface ConfirmResultFormData {
  conclusion: 'NEGATIVE' | 'POSITIVE' | 'UNDETERMINED'
}

export const confirmResultSchema: RJSFSchema = {
  type: 'object',
  properties: {
    conclusion: {
      type: 'string',
      title: 'Resultat',
      oneOf: [
        {
          const: 'NEGATIVE',
          title: 'Ikke påvist'
        },
        {
          const: 'POSITIVE',
          title: 'Påvist'
        },
        {
          const: 'UNDETERMINED',
          title: 'Ikke vurdert'
        }
      ]
    }
  },
  required: ['conclusion']
}
